import { useHighlight } from '../../../contexts/highlight-provider/useHighlight';
import { cn } from '../../../utils/common-utils';
import { HighlightStickersWrapperProps } from './types';
import HighlightSticker from './highlight-sticker';

const HighlightStickersWrapper = ({
  className,
  questionId,
  ...props
}: HighlightStickersWrapperProps): JSX.Element | null => {
  const { highlightData } = useHighlight();

  const stickers = highlightData.filter(
    (hl) => hl.questionId === questionId && hl.sticker.isNeedSticker,
  );

  if (!stickers.length) return null;

  return (
    <div
      key={'HighlightStickersWrapper'}
      className={cn(
        'flex flex-col items-stretch gap-2 border-r-2 border-[#C9CDD4] px-2 pt-12',
        className,
      )}
      {...props}
    >
      {stickers.map((hl) => {
        return <HighlightSticker data={hl} key={hl.keyId} />;
      })}
    </div>
  );
};

export default HighlightStickersWrapper;
